import React from "react";
import { Dropdown } from "components/commons";
import styles from "./simple-dropdown.module.scss";
// import { DownOutlined } from "@ant-design/icons";
import classnames from "classnames";
import { Icon } from "components/commons";

const SimpleDropdown = ({
  text,
  classname,
  color,
  trigger,
  iconName = "caret-down",
  iconStyle = "text-xxs",
  container = styles.container,
  ...dropdownProps
}) => {
  return (
    <Dropdown trigger={trigger} {...dropdownProps}>
      <div className={classname ? classname : classnames(container)}>
        <div className={classnames(styles.text)}>{text}</div>
        {/* <DownOutlined className={(classnames(styles.icon), color)} /> */}
        <Icon name={iconName} className={iconStyle} color={color} />
      </div>
    </Dropdown>
  );
};

export default SimpleDropdown;
